"use strict";

import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _AsyncBoundary;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.starts-with.js";
import "core-js/modules/esnext.string.replace-all.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { c as _c } from "react/compiler-runtime";
import { logout } from '@autoguru/auth';
import { IS_PRODUCTION } from '@autoguru/global-configs';
import { PowerIcon } from '@autoguru/icons';
import { Box, Stack, Text } from '@autoguru/overdrive';
import { AsyncBoundary } from '@autoguru/suspense';
import { lazy, useCallback, useMemo } from 'react';
import { useExpandSideNav } from '../ExpandSideNavProvider';
import * as styles from './ExpandSideNavLinks.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const ExpandCopyAccessToken = /*#__PURE__*/lazy(async () => import('../ExpandCopyAccessToken'));
const ExpandSideNavMobileLink = /*#__PURE__*/lazy(async () => import('../ExpandSideNavMobileLink/ExpandSideNavMobileLink'));
const ExpandSideNavLink = /*#__PURE__*/lazy(async () => import('../ExpandSideNavLink/ExpandSideNavLink'));
const replaceToken = (value, token, tokenValue) => value.replaceAll(`#[${token}\]`, tokenValue);
const hasUnresolvedToken = value => /(\#\[.*\])/.test(value);
const ExpandLinkGroup = t0 => {
  const $ = _c(23);
  const {
    label,
    links,
    labelClassName,
    stringTokens,
    activeLinkChecker,
    isAuthed,
    viewerAccess
  } = t0;
  let t1;
  if ($[0] !== stringTokens) {
    t1 = link => {
      if (!link) {
        return null;
      }
      let processedLink = link;
      if (stringTokens) {
        for (const token of Object.keys(stringTokens)) {
          processedLink = replaceToken(processedLink, token, stringTokens[token]);
        }
      }
      return processedLink;
    };
    $[0] = stringTokens;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const linkParser = t1;
  let t2;
  if ($[2] !== activeLinkChecker) {
    t2 = link_0 => typeof activeLinkChecker === "function" ? activeLinkChecker(link_0) : location.href.startsWith(link_0);
    $[2] = activeLinkChecker;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isActiveChecker = t2;
  let t3;
  if ($[4] !== label) {
    t3 = label ? /*#__PURE__*/_jsx(Text, {
      size: "2",
      transform: "uppercase",
      colour: "muted",
      children: label
    }) : null;
    $[4] = label;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  let t5;
  if ($[6] !== isActiveChecker || $[7] !== isAuthed || $[8] !== labelClassName || $[9] !== linkParser || $[10] !== links || $[11] !== viewerAccess) {
    let _t;
    if ($[13] !== viewerAccess) {
      _t = t7 => {
        const {
          requiredAccess
        } = t7;
        return !requiredAccess || viewerAccess.includes(requiredAccess);
      };
      $[13] = viewerAccess;
      $[14] = _t;
    } else {
      _t = $[14];
    }
    let t7;
    if ($[15] !== isActiveChecker || $[16] !== isAuthed || $[17] !== labelClassName || $[18] !== linkParser) {
      t7 = (t8, index) => {
        const {
          label: label_0,
          icon,
          iconSrc,
          iconColour,
          to,
          AuthedOverlay,
          Component,
          checkIsVisible,
          IfAuthedComponent,
          fullWidth,
          target,
          isLink: t9
        } = t8;
        const isLink = t9 === undefined ? true : t9;
        const link_1 = linkParser(to);
        const props = isLink ? {
          to: link_1
        } : {
          onClick: () => window.open(link_1, "SupplierPortalLegacy", "popup")
        };
        return /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: null,
          errorFallback: null,
          children: /*#__PURE__*/_jsx(ExpandSideNavLink, _objectSpread(_objectSpread({
            isAuthed: isAuthed,
            checkIsVisible: checkIsVisible,
            labelClassName: labelClassName,
            label: label_0,
            icon: icon,
            iconSrc: iconSrc,
            iconColour: iconColour,
            Component: Component,
            IfAuthedComponent: IfAuthedComponent,
            AuthedOverlay: AuthedOverlay,
            fullWidth: fullWidth,
            target: target,
            disabled: hasUnresolvedToken(link_1)
          }, props), {}, {
            isActive: isActiveChecker(to)
          }))
        }, index);
      };
      $[15] = isActiveChecker;
      $[16] = isAuthed;
      $[17] = labelClassName;
      $[18] = linkParser;
      $[19] = t7;
    } else {
      t7 = $[19];
    }
    t5 = links.filter(_t).map(t7);
    $[6] = isActiveChecker;
    $[7] = isAuthed;
    $[8] = labelClassName;
    $[9] = linkParser;
    $[10] = links;
    $[11] = viewerAccess;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  t4 = t5;
  let t6;
  if ($[20] !== t3 || $[21] !== t4) {
    t6 = /*#__PURE__*/_jsxs(Stack, {
      is: "nav",
      space: "none",
      children: [t3, t4]
    });
    $[20] = t3;
    $[21] = t4;
    $[22] = t6;
  } else {
    t6 = $[22];
  }
  return t6;
};
const ExpandLinkGroupMobileView = t0 => {
  const $ = _c(24);
  const {
    label,
    links,
    labelClassName,
    stringTokens,
    activeLinkChecker,
    isAuthed,
    viewerAccess,
    showItemFullWidth
  } = t0;
  let t1;
  if ($[0] !== stringTokens) {
    t1 = link => {
      if (!link) {
        return null;
      }
      let processedLink = link;
      if (stringTokens) {
        for (const token of Object.keys(stringTokens)) {
          processedLink = replaceToken(processedLink, token, stringTokens[token]);
        }
      }
      return processedLink;
    };
    $[0] = stringTokens;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const linkParser = t1;
  let t2;
  if ($[2] !== activeLinkChecker) {
    t2 = link_0 => typeof activeLinkChecker === "function" ? activeLinkChecker(link_0) : location.href.startsWith(link_0);
    $[2] = activeLinkChecker;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  const isActiveChecker = t2;
  const t3 = showItemFullWidth ? styles.navItemsMobileFullWidth : styles.navItemsMobile;
  let t4;
  if ($[4] !== label) {
    t4 = label ? /*#__PURE__*/_jsx(Text, {
      size: "2",
      transform: "uppercase",
      colour: "muted",
      children: label
    }) : null;
    $[4] = label;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  let t6;
  if ($[6] !== isActiveChecker || $[7] !== isAuthed || $[8] !== labelClassName || $[9] !== linkParser || $[10] !== links || $[11] !== viewerAccess) {
    let _t2;
    if ($[13] !== viewerAccess) {
      _t2 = t8 => {
        const {
          requiredAccess
        } = t8;
        return !requiredAccess || viewerAccess.includes(requiredAccess);
      };
      $[13] = viewerAccess;
      $[14] = _t2;
    } else {
      _t2 = $[14];
    }
    let t8;
    if ($[15] !== isActiveChecker || $[16] !== isAuthed || $[17] !== labelClassName || $[18] !== linkParser) {
      t8 = (t9, index) => {
        const {
          label: label_0,
          icon,
          iconSrc,
          iconColour,
          to,
          AuthedOverlay,
          Component,
          checkIsVisible,
          IfAuthedComponent,
          fullWidth,
          target,
          isLink: t10
        } = t9;
        const isLink = t10 === undefined ? true : t10;
        const link_1 = linkParser(to);
        const props = isLink ? {
          to: link_1
        } : {
          onClick: () => window.open(link_1, "SupplierPortalLegacy", "popup")
        };
        return /*#__PURE__*/_jsx(AsyncBoundary, {
          fallback: null,
          errorFallback: null,
          children: /*#__PURE__*/_jsx(ExpandSideNavMobileLink, _objectSpread(_objectSpread({
            isAuthed: isAuthed,
            checkIsVisible: checkIsVisible,
            labelClassName: labelClassName,
            label: label_0,
            icon: icon,
            iconSrc: iconSrc,
            iconColour: iconColour,
            Component: Component,
            IfAuthedComponent: IfAuthedComponent,
            AuthedOverlay: AuthedOverlay,
            fullWidth: fullWidth,
            target: target,
            disabled: hasUnresolvedToken(link_1)
          }, props), {}, {
            isActive: isActiveChecker(to)
          }))
        }, index);
      };
      $[15] = isActiveChecker;
      $[16] = isAuthed;
      $[17] = labelClassName;
      $[18] = linkParser;
      $[19] = t8;
    } else {
      t8 = $[19];
    }
    t6 = links.filter(_t2).map(t8);
    $[6] = isActiveChecker;
    $[7] = isAuthed;
    $[8] = labelClassName;
    $[9] = linkParser;
    $[10] = links;
    $[11] = viewerAccess;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  t5 = t6;
  let t7;
  if ($[20] !== t3 || $[21] !== t4 || $[22] !== t5) {
    t7 = /*#__PURE__*/_jsxs(Box, {
      is: "nav",
      display: "grid",
      className: t3,
      paddingX: "3",
      children: [t4, t5]
    });
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  return t7;
};
export const ExpandSideNavLinks = t0 => {
  const $ = _c(50);
  const {
    className: t1,
    isAuthed,
    layout,
    minHeight
  } = t0;
  const className = t1 === undefined ? "" : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {};
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  const {
    asideItems,
    includeAuth,
    labelClassName,
    stringTokens,
    viewerAccess,
    logoutRedirect,
    logoutUrl,
    activeLinkChecker
  } = useExpandSideNav(t2);
  let t3;
  if ($[1] !== logoutRedirect || $[2] !== logoutUrl) {
    t3 = () => {
      if (logoutUrl) {
        const newTab = window.open(logoutUrl, "_blank");
        const listener = event => {
          if (event.data === "logged-out") {
            newTab.close();
            logout(logoutRedirect);
            window.removeEventListener("message", listener);
          }
        };
        window.addEventListener("message", listener);
      } else {
        logout(logoutRedirect);
      }
    };
    $[1] = logoutRedirect;
    $[2] = logoutUrl;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const onRequestLogout = t3;
  let t4;
  if ($[4] !== className) {
    t4 = [className, styles.root];
    $[4] = className;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== minHeight) {
    t5 = {
      minHeight
    };
    $[6] = minHeight;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  let t6;
  if ($[8] !== activeLinkChecker || $[9] !== asideItems.header || $[10] !== isAuthed || $[11] !== labelClassName || $[12] !== layout || $[13] !== stringTokens || $[14] !== viewerAccess) {
    var _asideItems$header;
    t6 = (_asideItems$header = asideItems.header) !== null && _asideItems$header !== void 0 && _asideItems$header.length ? /*#__PURE__*/_jsx(_Fragment, {
      children: layout === "desktop" ? /*#__PURE__*/_jsx(Stack, {
        dividers: true,
        is: "ul",
        space: "4",
        children: asideItems.header.map(t7 => {
          const {
            label,
            links
          } = t7;
          return /*#__PURE__*/_jsx(ExpandLinkGroup, {
            isAuthed: isAuthed,
            labelClassName: labelClassName,
            label: label,
            links: links,
            viewerAccess: viewerAccess,
            stringTokens: stringTokens,
            activeLinkChecker: activeLinkChecker
          }, label);
        })
      }) : /*#__PURE__*/_jsx(Stack, {
        dividers: true,
        is: "ul",
        space: "4",
        children: asideItems.header.map(t8 => {
          const {
            label: label_0,
            links: links_0
          } = t8;
          return /*#__PURE__*/_jsx(ExpandLinkGroupMobileView, {
            isAuthed: isAuthed,
            labelClassName: labelClassName,
            label: label_0,
            links: links_0,
            viewerAccess: viewerAccess,
            stringTokens: stringTokens,
            activeLinkChecker: activeLinkChecker,
            showItemFullWidth: true
          }, label_0);
        })
      })
    }) : null;
    $[8] = activeLinkChecker;
    $[9] = asideItems.header;
    $[10] = isAuthed;
    $[11] = labelClassName;
    $[12] = layout;
    $[13] = stringTokens;
    $[14] = viewerAccess;
    $[15] = t6;
  } else {
    t6 = $[15];
  }
  let t7;
  if ($[16] !== activeLinkChecker || $[17] !== asideItems.body || $[18] !== isAuthed || $[19] !== labelClassName || $[20] !== layout || $[21] !== stringTokens || $[22] !== viewerAccess) {
    var _asideItems$body;
    t7 = (_asideItems$body = asideItems.body) !== null && _asideItems$body !== void 0 && _asideItems$body.length ? layout === "desktop" ? /*#__PURE__*/_jsx(Stack, {
      dividers: true,
      is: "ul",
      space: "4",
      children: asideItems.body.map(t8 => {
        const {
          label: label_1,
          links: links_1
        } = t8;
        return /*#__PURE__*/_jsx(ExpandLinkGroup, {
          isAuthed: isAuthed,
          labelClassName: labelClassName,
          label: label_1,
          links: links_1,
          viewerAccess: viewerAccess,
          stringTokens: stringTokens,
          activeLinkChecker: activeLinkChecker
        }, label_1);
      })
    }) : /*#__PURE__*/_jsx(Stack, {
      dividers: true,
      is: "ul",
      space: "4",
      children: asideItems.body.map(t9 => {
        const {
          label: label_2,
          links: links_2
        } = t9;
        return /*#__PURE__*/_jsx(ExpandLinkGroupMobileView, {
          isAuthed: isAuthed,
          labelClassName: labelClassName,
          label: label_2,
          links: links_2,
          viewerAccess: viewerAccess,
          stringTokens: stringTokens,
          activeLinkChecker: activeLinkChecker
        }, label_2);
      })
    }) : null;
    $[16] = activeLinkChecker;
    $[17] = asideItems.body;
    $[18] = isAuthed;
    $[19] = labelClassName;
    $[20] = layout;
    $[21] = stringTokens;
    $[22] = viewerAccess;
    $[23] = t7;
  } else {
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t6 || $[25] !== t7) {
    t8 = /*#__PURE__*/_jsxs(Stack, {
      space: "2",
      children: [t6, t7]
    });
    $[24] = t6;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  let t9;
  if ($[27] !== asideItems.footer || $[28] !== isAuthed || $[29] !== labelClassName || $[30] !== stringTokens || $[31] !== viewerAccess) {
    var _asideItems$footer;
    t9 = (_asideItems$footer = asideItems.footer) !== null && _asideItems$footer !== void 0 && _asideItems$footer.length ? /*#__PURE__*/_jsx(Stack, {
      dividers: true,
      is: "ul",
      space: "4",
      children: asideItems.footer.map(t10 => {
        const {
          label: label_3,
          links: links_3
        } = t10;
        return /*#__PURE__*/_jsx(ExpandLinkGroup, {
          isAuthed: isAuthed,
          labelClassName: labelClassName,
          viewerAccess: viewerAccess,
          stringTokens: stringTokens,
          label: label_3,
          links: links_3
        }, label_3);
      })
    }) : null;
    $[27] = asideItems.footer;
    $[28] = isAuthed;
    $[29] = labelClassName;
    $[30] = stringTokens;
    $[31] = viewerAccess;
    $[32] = t9;
  } else {
    t9 = $[32];
  }
  let t10;
  if ($[33] !== includeAuth || $[34] !== isAuthed) {
    t10 = !isAuthed || !includeAuth || JSON.parse(IS_PRODUCTION) ? null : _AsyncBoundary || (_AsyncBoundary = /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: null,
      errorFallback: null,
      children: /*#__PURE__*/_jsx(ExpandCopyAccessToken, {})
    }));
    $[33] = includeAuth;
    $[34] = isAuthed;
    $[35] = t10;
  } else {
    t10 = $[35];
  }
  let t11;
  if ($[36] !== includeAuth || $[37] !== isAuthed || $[38] !== labelClassName || $[39] !== onRequestLogout) {
    t11 = isAuthed && includeAuth && /*#__PURE__*/_jsx(AsyncBoundary, {
      fallback: null,
      errorFallback: null,
      children: /*#__PURE__*/_jsx(ExpandSideNavLink, {
        labelClassName: labelClassName,
        label: "Log out",
        to: null,
        icon: PowerIcon,
        isAuthed: isAuthed,
        onClick: onRequestLogout,
        isActive: false
      })
    });
    $[36] = includeAuth;
    $[37] = isAuthed;
    $[38] = labelClassName;
    $[39] = onRequestLogout;
    $[40] = t11;
  } else {
    t11 = $[40];
  }
  let t12;
  if ($[41] !== t10 || $[42] !== t11) {
    t12 = /*#__PURE__*/_jsxs(Stack, {
      space: "none",
      children: [t10, t11]
    });
    $[41] = t10;
    $[42] = t11;
    $[43] = t12;
  } else {
    t12 = $[43];
  }
  let t13;
  if ($[44] !== t12 || $[45] !== t4 || $[46] !== t5 || $[47] !== t8 || $[48] !== t9) {
    t13 = /*#__PURE__*/_jsxs(Box, {
      is: "aside",
      width: "full",
      className: t4,
      style: t5,
      children: [t8, t9, t12]
    });
    $[44] = t12;
    $[45] = t4;
    $[46] = t5;
    $[47] = t8;
    $[48] = t9;
    $[49] = t13;
  } else {
    t13 = $[49];
  }
  return t13;
};